import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import CloseSheet, {
  CloseReasonOption,
} from "@coworker/apprestructured/src/task-management/components/CloseSheet/CloseSheet";

const OPTIONS: CloseReasonOption[] = [
  {
    value: "invalid",
    label: "Invalid",
    requiresDescription: false,
  },
  {
    value: "already_resolved",
    label: "Already resolved",
    requiresDescription: false,
  },
  {
    value: "not_in_stock",
    label: "Not in stock",
    requiresDescription: false,
  },
  {
    value: "duplicate",
    label: "Duplicated task",
    requiresDescription: false,
  },
  {
    value: "other",
    label: "Other",
    requiresDescription: true,
  },
];

function CloseSheetDemo() {
  const [open, setOpen] = useState(false);
  const [closeReasonId, setCloseReasonId] = useState<string | null>(null);
  const [description, setDescription] = useState("");

  return (
    <Demo>
      <Name>CloseSheet</Name>
      <Highlight>
        <>
          <FixaButton type="tertiary" onClick={() => setOpen(true)}>
            Open
          </FixaButton>
          <CloseSheet
            closeReasonId={closeReasonId}
            onCloseReasonIdChange={setCloseReasonId}
            options={OPTIONS}
            description={description}
            onDescriptionChange={setDescription}
            visible={open}
            onClose={() => setOpen(false)}
            onCloseTask={() => {
              alert("onCloseTaskClick");
            }}
          />
        </>
      </Highlight>
    </Demo>
  );
}

export default memo(CloseSheetDemo);
